import {AppstoreAddOutlined} from '@ant-design/icons';
import CalendarIcon from 'components/icons/Calendar';
import CarsIcon from 'components/icons/Cars';
import CustomersIcon from 'components/icons/Customers';
import DashboardIcon from 'components/icons/Dashboard';
import InventoryIcon from 'components/icons/Inventory';
import InvoicesIcon from 'components/icons/Invoices';
import MailIcon from 'components/icons/Mail';
import ServicesIcon from 'components/icons/Services';
import SupportIcon from 'components/icons/Support';
import TagsIcon from 'components/icons/Tags';
import VendorsIcon from 'components/icons/Vendors';
import WorkflowIcon from 'components/icons/Workflow';
import {APP_PREFIX_PATH} from 'configs/AppConfig';

const dashBoardNavTree = [
  {
    key: 'dashboard',
    path: `${APP_PREFIX_PATH}/dashboard`,
    title: 'Dashboard',
    Icon: DashboardIcon,
    breadcrumb: false,
    submenu: [],
  },
  {
    key: 'inbox',
    path: `${APP_PREFIX_PATH}/inbox`,
    title: 'Inbox',
    Icon: MailIcon,
    breadcrumb: false,
    submenu: [],
  },
  {
    key: 'calendar',
    path: `${APP_PREFIX_PATH}/calendar`,
    title: 'Calendar',
    Icon: CalendarIcon,
    breadcrumb: false,
    submenu: [],
  },
  {
    key: 'workflow',
    path: `${APP_PREFIX_PATH}/workflow`,
    title: 'Workflow',
    Icon: WorkflowIcon,
    breadcrumb: false,
    submenu: [],
  },
  {
    key: 'customers',
    path: `${APP_PREFIX_PATH}/customers`,
    title: 'Customers',
    Icon: CustomersIcon,
    breadcrumb: false,
    submenu: [],
  },
  {
    key: 'cars',
    path: `${APP_PREFIX_PATH}/cars`,
    title: 'Cars',
    Icon: CarsIcon,
    breadcrumb: false,
    submenu: [],
  },
  {
    key: 'invoices',
    path: `${APP_PREFIX_PATH}/invoices`,
    title: 'Invoices',
    Icon: InvoicesIcon,
    breadcrumb: false,
    submenu: [],
  },
  {
    key: 'inventory',
    path: `${APP_PREFIX_PATH}/inventory`,
    title: 'Inventory',
    Icon: InventoryIcon,
    breadcrumb: false,
    submenu: [],
  },
  {
    key: 'services',
    path: `${APP_PREFIX_PATH}/services`,
    title: 'Services',
    Icon: ServicesIcon,
    breadcrumb: false,
    submenu: [],
  },
  {
    key: 'vendors',
    path: `${APP_PREFIX_PATH}/vendors`,
    title: 'Vendors',
    Icon: VendorsIcon,
    breadcrumb: false,
    submenu: [],
  },
  {
    key: 'tags',
    path: `${APP_PREFIX_PATH}/tags`,
    title: 'Tags',
    Icon: TagsIcon,
    breadcrumb: false,
    submenu: [],
  },
  {
    key: 'applications',
    path: `${APP_PREFIX_PATH}/applications`,
    title: 'Applications',
    Icon: AppstoreAddOutlined,
    breadcrumb: false,
    submenu: [],
  },
  {
    key: 'support',
    path: `${APP_PREFIX_PATH}/support`,
    title: 'Support',
    Icon: SupportIcon,
    breadcrumb: false,
    submenu: [],
  },
];

const navigationConfig = [...dashBoardNavTree];

export default navigationConfig;
